module.exports = __webpack_public_path__ + "img/JT_icons01_64px_ALL.b1e25aee.svg";